
const ErrorMessage:React.FC<{message:string}> = ({message}) => {
   return (
    <div className="row pt-2">
        <div style={{ color: 'red', fontWeight: '300' }}>{message}</div>
    </div>
   );
}
export default ErrorMessage